import { IsNotEmpty, IsUUID } from 'class-validator';

import { NOT_EMPTY_OPTIONS } from '../../constants';

export class DetailPolicyVersion {
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  policy_version_id: string;

  @IsUUID()
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  employee_id: string;

  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  signature: string;
}
